<template lang="pug">
  .dropdown.languages-dropdown(:class="{ 'is-active': activeDropdown, 'leftPosition': leftPosition }" v-on-away="away" ref="dropdown")
    .dropdown-trigger(@click="activeDropdown = !activeDropdown")
      button.button
        span {{ selected }}
    .dropdown-menu
      .dropdown-content
        span(@click="away()") +
        a.dropdown-item(
          href="#"
          v-if="items.length"
          v-for="(item, index) in items"
          :key="index"
          @click.prevent="select(item)") ({{item.short_name }}) {{ item.full_name }}
</template>
<script>
import { directive as onAway } from 'vue-clickaway'
const _ = require('lodash')

export default {
  name: 'LanguageSelector',
  data () {
    return {
      activeDropdown: false,
      leftPosition: false
    }
  },
  directives: {
    onAway
  },
  methods: {
    select (value) {
      this.$emit('selected', value)
      this.$emit('input', value)
      this.activeDropdown = false
    },
    away () {
      this.activeDropdown = false
    }
  },
  props: {
    items: {
      default: () => []
    },
    current: {
      default: 'en'
    }
  },
  filters: {
    toLower: function (value) {
      return value.toLowerCase()
    }
  },
  watch: {
    activeDropdown () {
      let x = this.$refs.dropdown.getBoundingClientRect().x
      let w = window.innerWidth
      if (x < w / 2) {
        this.leftPosition = true
      } else {
        this.leftPosition = false
      }
    }
  },
  computed: {
    selected () {
      let item = _.find(this.items, {'code': this.current})
      if (item) return _.toUpper(item.short_name)
      return _.toUpper(this.current)
    }
  }
}
</script>
<style lang="scss">
.languages-dropdown {
  &.leftPosition{
    .dropdown-menu{
      left: 0;
      right: auto;
    }
  }
  &.is-down {
    .dropdown-trigger {
      button {
        span {
          color: #fff
        }
        background-color: transparent;
      }
    }
    .dropdown-menu{
      top: auto;
      bottom: 40px;
      right: -15px;
      .dropdown-content {
        &:before, &:after{
          content: '';
          border: solid transparent;
          position: absolute;
          right: 15px;
          margin-left: -10px;
          bottom: -24px;
          width: 0;
        }
        &:before {
          border-top-color: gray;
          border-width: 12px;
        }
        &:after {
          border-top-color: #fff;
          border-width: 14px;
          margin-left: -16px;
          right: 13px;
        }
        a.dropdown-item{
          background: #e6e6e6;
        }
      }
    }
  }
  .dropdown-trigger {
    display: flex;
    justify-content: center;
    align-items: center;
    button {
      height: 95%;
      border: none;
      outline: none;
      box-shadow: none;
      padding: 0 0;
      border-radius: 0;
      border-bottom: 4px solid #bb1d2c;
      &:focus {
        border-bottom: 4px solid #bb1d2c;
        outline: none;
        box-shadow: none;
      }
      span {
        color: #262a40;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        text-transform: uppercase;
      }
    }
  }
  .dropdown-menu {
    min-width: auto;
    top: 60px;
    left: auto;
    right: 0;
    .dropdown-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      padding: 5px;
      border-radius: 0;
      span{
        display: none;
      }
      a.dropdown-item {
        display: inline-block;
        float: left;
        padding: 4px 10px;
        margin: 4px;
        background: #e6e6e6;
        &:hover{
          background: #8e8e8e;
        }
      }
    }
  }
}
@media screen and (max-width: 1087px) {
  .languages-dropdown {
    .dropdown-menu {
      top: 45px;
    }
  }
}
@media screen and (max-width: 768px) {
  .languages-dropdown {
    .dropdown-menu {
      top: 30px;
    }
  }
  header {
    .languages-dropdown {
      &.is-down {

      }
      .dropdown-menu {
        position: fixed;
        top: 0;
        left: 0;
        right: auto;
        width: 100%;
        transform: none;
        background: #000000d4;
        height: 100%;
        .dropdown-content {
          grid-template-columns: 1fr;
          margin: 4rem 1rem 2rem 1rem;
          overflow-x: scroll;
          max-height: calc(100% - 20%);
          span{
            display: inline-block;
            cursor: pointer;
            position: absolute;
            top: 5px;
            right: 0;
            font-size: 4rem;
            transform: rotate(45deg);
            line-height: .6;
            padding: .5rem;
            color: #fff;
          }
        }
      }
    }
  }
  footer {
    .languages-dropdown {
      &.is-down {
        .dropdown-menu {
          position: fixed;
          top: 0;
          left: 0;
          right: auto;
          width: 100%;
          transform: none;
          background: #000000d4;
          height: 100%;
          z-index: 100;
          .dropdown-content {
            grid-template-columns: 1fr;
            margin: 4rem 1rem 2rem 1rem;
            overflow-x: scroll;
            max-height: calc(100% - 20%);
            &:before, &:after{
              content: none;
            }
            span{
              display: inline-block;
              cursor: pointer;
              position: absolute;
              top: 5px;
              right: 0;
              font-size: 4rem;
              transform: rotate(45deg);
              line-height: .6;
              padding: .5rem;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
@media (max-height: 380px) and (min-width: 1100px){
  header {
    .languages-dropdown {
      &.is-down {

      }
      .dropdown-menu {
        position: fixed;
        top: 0;
        left: 0;
        right: auto;
        width: 100%;
        transform: none;
        background: #000000d4;
        height: 100%;
        .dropdown-content {
          grid-template-columns: 1fr;
          margin: 4rem 1rem 2rem 1rem;
          overflow-x: scroll;
          max-height: calc(100% - 20%);
          span{
            display: inline-block;
            cursor: pointer;
            position: absolute;
            top: 5px;
            right: 0;
            font-size: 4rem;
            transform: rotate(45deg);
            line-height: .6;
            padding: .5rem;
            color: #fff;
          }
        }
      }
    }
  }
}
@media (max-height: 680px) and (max-width: 1100px){
  header {
    .languages-dropdown {
      &.is-down {

      }
      .dropdown-menu {
        position: fixed;
        top: 0;
        left: 0;
        right: auto;
        width: 100%;
        transform: none;
        background: #000000d4;
        height: 100%;
        .dropdown-content {
          grid-template-columns: 1fr;
          margin: 4rem 1rem 2rem 1rem;
          overflow-x: scroll;
          max-height: calc(100% - 20%);
          span{
            display: inline-block;
            cursor: pointer;
            position: absolute;
            top: 5px;
            right: 0;
            font-size: 4rem;
            transform: rotate(45deg);
            line-height: .6;
            padding: .5rem;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/language-selector/index.vue